import { useGetAutomationFailures } from '@urbanx/agx.support.client';
import type { AutomationFailureListQuery } from './automationFailureQuery';

export const useAutomationFailureList = (
  query: AutomationFailureListQuery,
  continuationToken?: string,
  pageSize?: number
) =>
  useGetAutomationFailures(
    query.search,
    query.area,
    query.reason,
    query.agencyId,
    query.campaignId,
    query.status,
    query.occurredFromUtc,
    query.occurredToUtc,
    continuationToken,
    pageSize
  );
